import React, { useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import { useDispatch, useSelector } from "react-redux";
import { fetchMemory, entrySourceModified, entryTargetModified, saveMemoryModifications } from "./../../redux/ducks/memory";
import useStatusThunk from "../../hook/useStatusThunk";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import useAuthEffect from "../../hook/useAuthEffect";
import RouteHeader from "../../components/dumb/RouteHeader";
import { Row, Table } from "../../components/dumb/DataTable";
import ExportMemory from "../../components/smart/buttonPopups/ExportMemory";
import LanguageSelect from "../../components/smart/LanguageSelect";
import { useRef } from "react";
import SetMemoryName from "../../components/smart/buttonPopups/SetMemoryName";
import ImportMemory from "../../components/smart/buttonPopups/ImportMemory";

const MemoryRoute = ({ match }) => {

    const memoryID = match.params.memoryID;
    const dispatch = useDispatch();
    const memory = useSelector(state => state.memory.memories[memoryID]);
    const [dispatchFetchMemory, status, error] = useStatusThunk(fetchMemory);
    const [rows, setRows] = useState([]);
    const [activeLang, setActiveLang] = useState(null);
    const [targetLangs, setTargetLangs] = useState([]);

    const activeLangRef = useRef();

    activeLangRef.current = activeLang;

    useAuthEffect(isAuth => dispatchFetchMemory({ memoryID }));

    useEffectWithoutLoad(() => {
        if (status == "success") {
            let langs = [];
            memory.entries.forEach(entry => {
                entry.targets.forEach(target => {
                    if (!langs.includes(target.lang)) langs.push(target.lang);
                });
            });
            setTargetLangs(langs);

            setRows(memory.entries.map((entry, index) => {
                const target = entry.targets.find(target => target.lang == activeLang);
                return {
                    ID: entry.id,
                    index,
                    source: entry.source,
                    target: target?.text,
                    targetModifiedBy: target?.modifiedBy,
                    targetModifiedDate: target?.modifiedDate,
                    modified: entry?.modified
                }
            }));
        }
    }, [status, memory?.entries, activeLang]);

    const sourceModified = (ID, text) => dispatch(entrySourceModified({ entryID: ID, memoryID, sourceText: text }));
    const targetModified = (ID, text) => dispatch(entryTargetModified({ entryID: ID, memoryID, targetText: text, targetLang: activeLangRef.current }));

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="memories" />
            </div>

            <div className="column column--primary">
                <RouteHeader title={<React.Fragment>{memory?.name} <SetMemoryName memoryID={memoryID}/></React.Fragment>} data={{ ID: memoryID, note: memory?.note, "source lang": memory?.sourceLang, size: memory?.size, created: memory?.created }} />

                <Entries targetLangs={targetLangs} setTargetLang={setActiveLang} rows={rows} memoryID={memoryID} targetLang={activeLang} sourceLang={memory?.sourceLang} entrySourceModified={sourceModified} entryTargetModified={targetModified} />
            </div>
        </div>
    )
}


const Entries = props => {
    const dispatch = useDispatch();

    const renderRow = (row, renderData, extra) => <Row className={"entry-row " + (row.modified ? "entry-row--modified" : "")}>
        {renderData(row.ID, { key: "id" })}
        {extra.renderTextareaData(row.source, { key: "source", onInput: text => { props.entrySourceModified(row.index, text) } })}
        {extra.renderTextareaData(row.target ? row.target : "", { key: "target", onInput: text => { props.entryTargetModified(row.index, text) } })}
        {renderData(row.targetModifiedBy ? row.targetModifiedBy : "", { key: "targetModifiedBy" })}
        {renderData(row.targetModifiedDate ? row.targetModifiedDate : "", { key: "targetModifiedDate" })}
    </Row>

    let titleContent = <React.Fragment>
        <ImportMemory memoryID={props.memoryID}/>
        <ExportMemory memoryID={props.memoryID} />
        <button className="button" onClick={() => { dispatch(saveMemoryModifications({ memoryID: props.memoryID })) }}>Save</button>
        <LanguageSelect prioritize={props.targetLangs} value={props.targetLang} onChange={e => props.setTargetLang(e.target.value)} className="select select--primary title-content__select" />
    </React.Fragment>

    return (
        <Table title="entries" titleContent={titleContent} renderRow={renderRow} customRow={true}
            rows={props.rows} cols={[
                { name: "id", sortCol: "ID" },
                { name: props.sourceLang, sortCol: "source" },
                { name: props.targetLang, sortCol: "target" },
                { name: "modified by", sortCol: "targetModifiedBy" },
                { name: "modified date", sortCol: "targetModifiedDate" },
            ]} />
    )
}

export default MemoryRoute;